
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Weddingdestinationnearbuldhana() {



  const cardData =
  {
    keyword: ' Wedding Destination Near Buldhana',
    heading:  'Woodland Escape: Wedding Destination Near Buldhana ',
    headingDescription: 'Woodland Escape Resort is an enchanting wedding destination near Buldhana, perfect for couples who dream of celebrating their special day amidst nature’s serenity. Surrounded by lush greenery, scenic landscapes, and tranquil forest views, the resort offers a romantic backdrop for both traditional and contemporary wedding celebrations. Spacious lawns, elegant décor options, and cozy accommodations make it ideal for hosting all wedding functions — from mehendi and sangeet to the grand reception. The resort’s dedicated team ensures every detail, from catering to decoration, is handled with care and precision. With its blend of natural beauty, comfort, and personalized service, Woodland Escape Resort near Buldhana transforms every wedding into a memorable celebration filled with charm, warmth, and timeless elegance.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Wedding Destination Near Buldhana",
      "description": "Discover the most enchanting wedding destinations near Buldhana where love meets luxury and nature. These scenic locations provide a perfect setting for grand celebrations, featuring lush gardens, open-air venues, and elegant banquet halls. Whether you dream of a traditional ceremony or a modern celebration, these destinations offer customized arrangements, catering, and décor to make your wedding truly unforgettable."
    },
    {
      "name": "Buldhana Wedding Venue",
      "description": "Find the perfect wedding venue in Buldhana that suits your style and budget. From luxurious resorts to charming open lawns and banquet halls, Buldhana offers a wide range of venues ideal for both intimate and grand celebrations. Each venue provides top-class hospitality, catering, and event management services to ensure your big day runs smoothly and beautifully."
    },
    {
      "name": "Buldhana Luxury Wedding Location",
      "description": "Host your dream wedding at one of Buldhana’s luxury wedding locations that blend elegance with world-class amenities. Enjoy breathtaking décor, premium accommodation, gourmet dining, and personalized event planning. Ideal for couples who wish to celebrate their special day in style, these venues provide the perfect mix of sophistication and comfort for a royal wedding experience."
    },
    {
      "name": "Affordable Wedding Spot Buldhana",
      "description": "Celebrate your wedding in style without breaking the bank at Buldhana’s affordable wedding spots. These venues offer beautiful spaces, professional services, and delicious catering within a reasonable budget. Perfect for families seeking elegant yet cost-effective venues, they provide decoration, music, and accommodation options that ensure a memorable wedding celebration for all."
    },
    {
      "name": "Buldhana Pre Wedding Shoot Location",
      "description": "Capture timeless memories before your big day at Buldhana’s stunning pre-wedding shoot locations. Choose from riverside backdrops, heritage sites, or scenic gardens that add a romantic charm to your photoshoot. These picturesque locations offer natural light, unique settings, and peaceful ambiance—ideal for couples who want to make their pre-wedding album truly special."
    },
    {
      "name": "Buldhana Outdoor Wedding Spot",
      "description": "Celebrate your love story under the open sky at Buldhana’s best outdoor wedding spots. With beautifully landscaped gardens, floral setups, and panoramic views, these venues create a magical atmosphere for your ceremony. Perfect for daytime weddings or evening receptions, outdoor venues provide flexibility, natural décor, and ample space for guests and entertainment."
    },
    {
      "name": "Buldhana Riverside Wedding Venue",
      "description": "Say 'I do' by the riverside at one of Buldhana’s tranquil and romantic wedding venues. Enjoy stunning water views, cool breezes, and scenic backdrops that make your wedding moments truly picturesque. These venues offer riverside mandaps, outdoor dining arrangements, and elegant décor—perfect for couples seeking a nature-inspired, peaceful, and luxurious celebration."
    },
    {
      "name": "Buldhana Hill Wedding Location",
      "description": "Tie the knot amidst the cool breeze and breathtaking views at a hill wedding location in Buldhana. Ideal for couples who love nature and serenity, these venues offer panoramic hilltop settings, private lawns, and cozy accommodation. Whether it’s a sunrise ceremony or a sunset reception, every moment here becomes magical and unforgettable."
    },
    {
      "name": "Buldhana Family Wedding Resort",
      "description": "Host your grand celebration at a family wedding resort in Buldhana designed to bring everyone together. Enjoy spacious lawns, multiple banquet halls, and luxury rooms for guests. These resorts provide full wedding packages, including décor, catering, music, and photography, ensuring every detail of your celebration is handled with care and professionalism."
    },
    {
      "name": "Buldhana Resort Wedding Packages",
      "description": "Choose from exclusive resort wedding packages in Buldhana that include venue decoration, catering, accommodation, and event coordination. These all-inclusive packages simplify your wedding planning and help you enjoy your big day without stress. Whether you want a lavish celebration or an intimate ceremony, these resorts tailor every element to match your vision."
    },
    {
      "name": "Buldhana Wedding Booking Online",
      "description": "Book your dream wedding venue in Buldhana online with ease. Browse through top-rated resorts, banquet halls, and open venues, compare packages, and reserve your preferred dates instantly. With transparent pricing, professional support, and secure bookings, online reservation ensures a hassle-free start to your wedding planning journey."
    },
    {
      "name": "Buldhana Wedding Hall",
      "description": "Find elegant and spacious wedding halls in Buldhana perfect for traditional and modern ceremonies. Equipped with air-conditioning, stage setups, and dining areas, these halls are designed to host large gatherings comfortably. Whether for engagement parties, receptions, or sangeet nights, Buldhana’s wedding halls offer a perfect balance of functionality and charm."
    },
    {
      "name": "Buldhana Marriage Destination",
      "description": "Turn your marriage into an unforgettable event at one of Buldhana’s premier marriage destinations. Surrounded by natural beauty and equipped with world-class amenities, these venues provide everything from luxury accommodation to event management. Create lasting memories as you celebrate your union in a setting that reflects your love and style."
    },
    {
      "name": "Buldhana Resort for Wedding",
      "description": "Celebrate your special day at a beautiful wedding resort in Buldhana offering elegant décor, professional catering, and luxurious guest rooms. With dedicated event coordinators, themed setups, and multiple indoor and outdoor venues, these resorts provide a seamless wedding experience tailored to your desires."
    },
    {
      "name": "Buldhana Wedding Destination Packages",
      "description": "Explore curated wedding destination packages in Buldhana that include everything you need for your big day—venue booking, catering, decoration, photography, and guest accommodation. These packages are customizable to suit your theme, guest count, and budget. Perfect for couples seeking convenience and excellence in one complete wedding solution."
    }
  ],
  "tableData": [
    ["- Wedding Destination Near Buldhana", "- Buldhana Wedding Venue"],
    ["- Buldhana Luxury Wedding Location", "- Affordable Wedding Spot Buldhana"],
    ["- Buldhana Pre Wedding Shoot Location", "- Buldhana Outdoor Wedding Spot"],
    ["- Buldhana Riverside Wedding Venue", "- Buldhana Hill Wedding Location"],
    ["- Buldhana Family Wedding Resort", "- Buldhana Resort Wedding Packages"],
    ["- Buldhana Wedding Booking Online", "- Buldhana Wedding Hall"],
    ["- Buldhana Marriage Destination", "- Buldhana Resort for Wedding"],
    ["- Buldhana Wedding Destination Packages", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Wedding Destination Near Buldhana",
    "WhyChoosedescription": "Woodland Escape Resort is an enchanting venue for weddings near Buldhana. With its lush green landscapes, serene ambiance, and elegant open spaces, it provides the perfect backdrop for a memorable celebration of love."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Venues",
    "WhyChoosedescription": "Exchange vows surrounded by nature in beautifully maintained gardens and forested surroundings. The resort’s natural beauty adds charm and elegance to every wedding moment."
  },
  {
    "WhyChooseheading": "Spacious Banquet and Lawn Areas",
    "WhyChoosedescription": "Woodland Escape Resort offers expansive lawns and flexible event spaces that can be customized for wedding ceremonies, receptions, and pre-wedding functions, accommodating both intimate and grand gatherings."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation for Guests",
    "WhyChoosedescription": "The resort provides comfortable lodging options for guests, ensuring a relaxed and enjoyable stay throughout the wedding festivities. Each room is designed to offer warmth and modern comfort."
  },
  {
    "WhyChooseheading": "Customized Wedding Planning Support",
    "WhyChoosedescription": "From decor and catering to logistics and entertainment, the resort team assists in planning every detail to create a seamless and personalized wedding experience."
  },
  {
    "WhyChooseheading": "Delicious Catering and Cuisine",
    "WhyChoosedescription": "Treat your guests to a delightful culinary experience with freshly prepared multi-cuisine menus. The resort’s chefs craft dishes that perfectly complement your wedding celebrations."
  },
  {
    "WhyChooseheading": "Convenient Location from Buldhana",
    "WhyChoosedescription": "Located just a short drive from Buldhana, Woodland Escape Resort combines accessibility with tranquility, making it the ideal wedding destination for couples seeking a scenic yet convenient venue."
  }
]



















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a wedding destination near Buldhana?",
    answer: "Woodland Escape Resort is one of the most beautiful and peaceful wedding destinations near Buldhana. Surrounded by lush greenery and open lawns, it offers a perfect natural setting for dream weddings and grand celebrations."
  },
  {
    question: "How far is Woodland Escape Resort from Buldhana city?",
    answer: "The resort is around 35–40 km from Buldhana, making it conveniently accessible for guests. Its close proximity makes it ideal for destination weddings without long travel times."
  },
  {
    question: "What wedding facilities are available at Woodland Escape Resort?",
    answer: "The resort offers spacious banquet lawns, elegant décor options, catering services, and comfortable accommodation for guests. Whether it’s a traditional or modern wedding, the venue can be customized to your preferences."
  },
  {
    question: "Can Woodland Escape Resort host pre-wedding and post-wedding events?",
    answer: "Yes! The resort is perfect for engagement ceremonies, mehendi, sangeet, reception, and other wedding-related events. The open and scenic environment makes every function memorable."
  },
  {
    question: "Does the resort provide catering and decoration services for weddings?",
    answer: "Absolutely. Woodland Escape Resort offers delicious catering options and professional decoration services to make your wedding celebrations beautiful, seamless, and stress-free."
  },
  {
    question: "How can we book Woodland Escape Resort as a wedding venue near Buldhana?",
    answer: "You can book by calling or sending a WhatsApp message to our reservations team, or by visiting our official website. It’s recommended to book well in advance to secure your preferred wedding dates."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Deshmukh, Buldhana",
    text: "Our wedding at Woodland Escape Resort was magical! The natural beauty, spacious lawns, and excellent arrangements made our big day unforgettable. Best wedding destination near Buldhana!"
  },
  {
    name: "Mr. Rohit & Family, Buldhana",
    text: "We attended a wedding at Woodland Escape Resort and were amazed by the setup. The decorations, food, and overall ambiance were top-notch. Highly recommended for weddings near Buldhana!"
  }
];



















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Destination Near Buldhana",
  "image": "https://woodlandescape.com/assets/images/wedding-destination-buldhana.jpg",
  "description": "Celebrate your dream wedding at Woodlandescape Resort, the perfect wedding destination near Buldhana. Offering luxury venues, scenic outdoor spots, riverside views, and customized wedding packages for families and couples.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "132"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "49999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/wedding-destination-buldhana"
  }
};



  return (
    <div>
<Helmet>
  <title>Wedding Destination Near Buldhana | Luxury & Scenic Wedding Venue | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Host your dream wedding at Woodlandescape Resort, the ideal wedding destination near Buldhana. Enjoy luxury venues, scenic outdoor spots, riverside views, and customized wedding packages for couples and families." 
  />
  <meta 
    name="keywords" 
    content="Wedding Destination Near Buldhana, Buldhana Wedding Venue, Buldhana Luxury Wedding Location, Affordable Wedding Spot Buldhana, Buldhana Pre Wedding Shoot Location, Buldhana Outdoor Wedding Spot, Buldhana Riverside Wedding Venue, Buldhana Hill Wedding Location, Buldhana Family Wedding Resort, Buldhana Resort Wedding Packages, Buldhana Wedding Booking Online, Buldhana Wedding Hall, Buldhana Marriage Destination, Buldhana Resort for Wedding, Buldhana Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/23.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Weddingdestinationnearbuldhana;